export const GrantType = {
  AUTHORIZATION_CODE_GRANT: 1,
};
